export default __webpack_public_path__ + "static/media/Fully_Secured.6f0758b2.svg";